var PlaylistUtility = (function ($) {
    return {
        formatTime: function (seconds) {
            if (seconds === 0) {
                return "00:00:00";
            }

            var date = new Date(1970, 0, 1);
            date.setSeconds(seconds);
            return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
        },
        insideIframe: function () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        setThumbnailParameters: function(urlTemplate, width, height, bgColor) {
            return urlTemplate
                .replace(/[{}]/g, '')
                .replace("width,", "width=" + width)
                .replace("height,", "&height=" + height)
                .replace("bgColor", "&bgColor=" + bgColor);
        },
        getIdentityRefreshInterval: function (identityQuery) {
            var searchParams = new URLSearchParams(identityQuery);

            var expiry = searchParams.get("idn_ri");
            if (expiry === undefined)
                return 0;

            console.log('Expiration Refresh Interval: ' + expiry);
            return expiry > 0 ? expiry : 0;
        },
        overrideParameter: function (originalUrl, parameter, value) {
            if (originalUrl === undefined || originalUrl === null ||
                parameter === null || parameter === undefined || parameter === '')
                return originalUrl;

            if (originalUrl.toLowerCase().indexOf(parameter.toLowerCase()) > -1) {
                originalUrl = originalUrl.replace(new RegExp('(' + parameter + '=).*?(&|$)', 'ig'), '$1' + value + '$2');
            } else {
                originalUrl = originalUrl.indexOf('?') > -1 || originalUrl.toLowerCase().indexOf('http') === -1
                    ? (originalUrl + '&' + parameter + '=' + value)
                    : (originalUrl + '?' + parameter + '=' + value);
            }

            return originalUrl;
        },
        overrideIdentityParams: function (originalUrl, idnParams) {
            for (var property in idnParams) {
                var value = idnParams[property];
                if (value !== undefined && value !== null && value !== "")
                    originalUrl = this.overrideParameter(originalUrl, property, value);
            }        

            return originalUrl;
        },
        setPreviewUrl: function (originalUrl, contentUrl, autoPlay, referrerQuery, viewCtxQuery) {            
            if (autoPlay)
                originalUrl = this.overrideParameter(originalUrl, "autoPlay", "true");

            originalUrl = this.overrideParameter(originalUrl, "isResponsive", "true");
            originalUrl = this.overrideParameter(originalUrl, "displayMenu", "false");
            originalUrl = this.setContentPreviewParameter(originalUrl, contentUrl);
            originalUrl = this.setShowCaptionsParameter(originalUrl, contentUrl);
            originalUrl = this.appendCustomQuery(originalUrl, referrerQuery);
            originalUrl = this.appendCustomQuery(originalUrl, viewCtxQuery);

            return originalUrl;
        },
        setLaunchUrl: function (originalUrl, contentQuery, referrerQuery, viewCtxQuery) {
            originalUrl = this.appendCustomQuery(originalUrl, contentQuery);
            originalUrl = this.appendCustomQuery(originalUrl, referrerQuery);
            originalUrl = this.appendCustomQuery(originalUrl, viewCtxQuery);

            return originalUrl;
        },
        appendCustomQuery: function (originalUrl, customQuery) {
            if (customQuery === undefined || customQuery === null || customQuery === '')
                return originalUrl;

            var $this = this;
            var searchParams = new URLSearchParams(customQuery);
            searchParams.forEach(function (value, key) {
                if (value !== undefined && value !== null && value !== "")
                    originalUrl = $this.overrideParameter(originalUrl, key, value);
            });

            return originalUrl;
        },
        setContentPreviewParameter: function(originalUrl, contentUrl) {
            if (contentUrl === undefined || contentUrl === null)
                return originalUrl;

            if (contentUrl.toLowerCase().indexOf("iscontentpreview=true") === -1)
                return originalUrl;

            originalUrl = (originalUrl.toLowerCase().indexOf("/quiz/") === -1)
                ? this.overrideParameter(originalUrl, "isContentPreview", "true")
                : this.overrideParameter(originalUrl, "isQuizPreview", "true");
            return originalUrl;
        },
        setShowCaptionsParameter: function (originalUrl, contentUrl) {
            if (contentUrl === undefined || contentUrl === null)
                return originalUrl;

            if (contentUrl.toLowerCase().indexOf("showcaptions=true") === -1)
                return originalUrl;

            originalUrl = this.overrideParameter(originalUrl, "showCaptions", "true");

            return originalUrl;
        },
        findByPropertyValue: function(array, property, value) {
            return array.filter(function(obj) {
                if (obj[property] === value) {
                    return obj;
                }

                return null;
            })[0];
        },
        getDefaultPlaybackSource: function(sources) {
            var $defaultSource = this.findByPropertyValue(sources, "isDefault", "true");
            if ($defaultSource === null || $defaultSource === undefined)
                $defaultSource = sources[0].filePath;

            return $defaultSource;
        },
        getStoragePreference: function (options) {
            var storagePreference;
            try {
                storagePreference = localStorage.getItem(options.key);
            } catch (e) {
                console.error(e.message);
            }
            if (!storagePreference)
                storagePreference = options.defaultValue;            

            return storagePreference;
        },
        getOrSetStoragePreference: function (options) {
            var storagePreference;
            try {
                storagePreference = localStorage.getItem(options.key);
            } catch (e) {
                console.error(e.message);
            }
            if (!storagePreference) {
                storagePreference = options.defaultValue;
                try {
                    localStorage.setItem(options.key, options.defaultValue);
                } catch (e) {
                    console.error(e.message);
                }
            }

            return storagePreference;
        },
        setStoragePreference: function (options) {
            try {
                localStorage.setItem(options.key, options.value);
            } catch (e) {
                console.error(e.message);
            }
        },
        stringToBool: function (value) {
            return value !== undefined && value !== null && value !== "" && value.toLowerCase() === "true";
        }
    };
})(jQuery);